export default __webpack_public_path__ + "static/media/faq.9ca8405a.svg";